import { useEffect, useRef, useState } from "react";
import { Box, Typography, Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

import synchroYou from "../assets/broadcast-moments/kbs-synchro-you-2024.jpg";
import namjin from "../assets/broadcast-moments/namjin-ai-concert-2024.jpg";
import election from "../assets/broadcast-moments/kbs-election-rap-battle-2024.jpg";
import ebsFuture from "../assets/broadcast-moments/ebs-future-jobs-documentary.jpg";
import seoldi from "../assets/broadcast-moments/kbs-coolfm-seoldi-vs-ai-seoldi-2023.jpg";
import sbsCover from "../assets/broadcast-moments/sbs-news-ai-cover-2023.jpg";
import yimJaeBum from "../assets/broadcast-moments/yim-jaebeom-ai-hidden-singer.jpg";
import deux from "../assets/broadcast-moments/deux-ai-2025.jpg";

const FEATURED = {
  image: deux,
  badges: ["LATEST", "MUSIC PRODUCTION"],
  meta: "DEUX · 2025",
  title: (
    <>
      듀스, AI로 다시
      <br />
      무대에 서다.
    </>
  ),
  description:
    "전설의 듀스(DEUX) — 그 시절의 사운드와 보이스를 AI로 정교하게 되살려, SoriSori AI가 함께한 신곡 작업.",
  cta: "WATCH NOW",
  href: "https://www.youtube.com/watch?v=_N4nrc2L-GQ",
};

const ITEMS = [
  {
    image: synchroYou,
    badge: "KBS 싱크로유",
    meta: "2024",
    title: "최정상 가수들과 펼치는 뮤직 버라이어티",
    description:
      "AI 가수와 진짜 가수의 소름 돋는 싱크로율. 1%의 차이를 발견해내는 버라이어티 뮤직쇼.",
    href: "https://www.youtube.com/watch?v=9hWEtE56KSg",
  },
  {
    image: namjin,
    badge: "NAMJIN",
    meta: "2024",
    title: "환갑 남진과 청춘 남진의 컬래버 콘서트",
    description:
      "AI 기술로 부활한 청춘 시절 남진과 현재의 남진이 한 무대에서 만나 함께 부르는 세대를 잇는 무대.",
    href: "https://www.youtube.com/watch?v=QU2A0jeEqzY",
  },
  {
    image: election,
    badge: "KBS",
    meta: "2024",
    title: "후보 공약을 랩으로 — AI 랩 배틀",
    description:
      "대선 후보들의 공약을 AI가 분석해 랩으로 풀어낸 공약 배틀. 정책 핵심을 한 줄로 꿰뚫는 트렌디한 정치 콘텐츠.",
    href: "https://www.youtube.com/watch?v=0qweCQkYvcM",
  },
  {
    image: ebsFuture,
    badge: "EBS",
    meta: "2024",
    title: "AI가 바꾸는 미래 직업 생태계",
    description:
      "AI가 바꾸는 PLAYER, 사라지는 직업과 새로 생기는 직업. 변화의 한가운데서 우리는 무엇을 준비해야 하는가.",
    href: "https://www.youtube.com/watch?v=O_WsjaH9-Lk&t=11s",
  },
  {
    image: seoldi,
    badge: "KBS Cool FM",
    meta: "2023",
    title: "설디 vs AI 설디 — 카리스마를 찾아라",
    description:
      "라디오를 점령한 'Cool With You' 작가 설디. AI 설디가 무대로 올라온다면? 진짜 1%를 찾아라.",
    href: "https://www.youtube.com/watch?v=icGSNSO4LPU&t=1751s",
  },
  {
    image: sbsCover,
    badge: "SBS NEWS",
    meta: "2023",
    title: "AI 커버 — 표현의 자유와 저작권",
    description:
      "AI 커버 곡이 폭발적으로 늘어나는 가운데 법적 쟁점은 무엇인지, 표현의 자유와 저작권의 균형을 짚어본다.",
    href: "https://www.youtube.com/watch?v=zT1N0ku3dYo",
  },
  {
    image: yimJaeBum,
    badge: "YIM JAE BUM",
    meta: "2024",
    title: "임재범 vs 임재범 AI — 진짜를 찾아라",
    description:
      "소리의 거장 임재범과 AI 임재범. 한 줄만으로 가슴을 찢어놓는 진짜 1%의 카리스마, 그 정체는?",
    href: "https://www.youtube.com/watch?v=vZeEzZe1B-4",
  },
];

const useStyles = makeStyles((theme) => ({
  root: { backgroundColor: "#0a0a0a", color: "#fff", minHeight: "100vh" },

  /* hero */
  hero: {
    position: "relative",
    padding: "200px 32px 120px",
    overflow: "hidden",
    "@media (max-width:600px)": { padding: "140px 24px 80px" },
  },
  heroBgGradient: {
    position: "absolute",
    inset: 0,
    background:
      "radial-gradient(ellipse 70% 50% at 50% 0%, rgba(250,255,105,0.10) 0%, transparent 60%), radial-gradient(ellipse 60% 70% at 80% 100%, rgba(167,139,250,0.08) 0%, transparent 60%)",
    pointerEvents: "none",
    zIndex: 0,
  },
  heroInner: {
    position: "relative",
    zIndex: 1,
    maxWidth: 1280,
    margin: "0 auto",
    textAlign: "center",
  },
  heroLabel: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "3px",
    textTransform: "uppercase",
    color: theme.palette.primary.main,
    marginBottom: 24,
    opacity: 0,
    animation: "$slideUp .7s .05s ease-out forwards",
  },
  heroTitle: {
    fontSize: "clamp(56px, 9vw, 120px)",
    fontWeight: 800,
    letterSpacing: "-4px",
    lineHeight: 0.95,
    margin: 0,
    color: "#fff",
    opacity: 0,
    animation: "$slideUp .9s .15s ease-out forwards",
    "@media (max-width:600px)": { letterSpacing: "-2px" },
  },
  heroSub: {
    fontSize: 17,
    color: "rgba(255,255,255,0.65)",
    maxWidth: 560,
    margin: "32px auto 0",
    lineHeight: 1.65,
    opacity: 0,
    animation: "$slideUp .9s .3s ease-out forwards",
  },

  /* shared keyframes */
  "@keyframes slideUp": {
    "0%": { opacity: 0, transform: "translateY(28px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes fadeIn": {
    "0%": { opacity: 0, transform: "translateY(20px) scale(.98)" },
    "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
  },
  "@keyframes shimmer": {
    "0%": { transform: "translateX(-100%)" },
    "100%": { transform: "translateX(100%)" },
  },

  /* section wrapper */
  section: {
    padding: "0 32px 120px",
    "@media (max-width:600px)": { padding: "0 20px 80px" },
  },
  inner: { maxWidth: 1280, margin: "0 auto" },

  /* solo hero — featured (Deux) takes full width */
  featured: {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "1.35fr 1fr",
    gap: 0,
    backgroundColor: "#101010",
    borderRadius: 20,
    overflow: "hidden",
    border: "1px solid rgba(255,255,255,0.08)",
    textDecoration: "none",
    color: "inherit",
    cursor: "pointer",
    transition: "border-color .4s, transform .4s",
    "&:hover": {
      borderColor: "rgba(250,255,105,0.32)",
      transform: "translateY(-4px)",
    },
    "&:hover $featuredImage": { transform: "scale(1.04)" },
    "&:hover $watchBtn": {
      background: theme.palette.primary.main,
      color: "#0a0a0a",
      borderColor: theme.palette.primary.main,
    },
    "@media (max-width:900px)": { gridTemplateColumns: "1fr" },
  },
  featuredImageWrap: {
    position: "relative",
    width: "100%",
    height: "100%",
    minHeight: 460,
    overflow: "hidden",
    "@media (max-width:900px)": { aspectRatio: "16 / 10", minHeight: 0 },
    "@media (max-width:600px)": { aspectRatio: "16 / 11" },
  },
  featuredImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    transition: "transform .8s cubic-bezier(.2,.7,.2,1)",
  },
  featuredImageOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, transparent 60%, rgba(0,0,0,0.45) 100%)",
    pointerEvents: "none",
  },
  featuredBody: {
    padding: "56px 56px 52px",
    display: "flex",
    flexDirection: "column",
    gap: 18,
    justifyContent: "center",
    "@media (max-width:1100px)": { padding: "40px 40px 40px" },
    "@media (max-width:600px)": { padding: "32px 28px 36px" },
  },
  featuredTitle: {
    fontSize: 40,
    fontWeight: 800,
    lineHeight: 1.18,
    color: "#fff",
    letterSpacing: "-1px",
    margin: 0,
    "@media (max-width:1100px)": { fontSize: 32 },
    "@media (max-width:600px)": { fontSize: 26 },
  },
  featuredDesc: {
    fontSize: 16,
    lineHeight: 1.7,
    color: "rgba(255,255,255,0.68)",
    margin: 0,
    "@media (max-width:600px)": { fontSize: 14 },
  },
  watchBtn: {
    alignSelf: "flex-start",
    color: theme.palette.primary.main,
    border: `1px solid rgba(250,255,105,0.4)`,
    borderRadius: 999,
    padding: "11px 24px",
    fontSize: 12,
    letterSpacing: "2px",
    fontWeight: 700,
    marginTop: 8,
    transition: "background .25s, color .25s, border-color .25s",
  },
  badgeRow: { display: "flex", gap: 8, flexWrap: "wrap" },
  badgeFeatured: {
    backgroundColor: theme.palette.primary.main,
    color: "#0a0a0a",
    fontWeight: 700,
    height: 24,
    fontSize: 11,
    letterSpacing: "1.5px",
    borderRadius: 999,
  },
  badgeMuted: {
    backgroundColor: "rgba(255,255,255,0.08)",
    color: "#fff",
    fontWeight: 600,
    height: 24,
    fontSize: 11,
    letterSpacing: "1.5px",
    borderRadius: 999,
  },
  meta: {
    fontSize: 12,
    letterSpacing: "2px",
    color: "rgba(255,255,255,0.5)",
    marginTop: 4,
  },
  featuredTitle: {
    fontSize: 24,
    fontWeight: 800,
    lineHeight: 1.25,
    color: "#fff",
    letterSpacing: "-0.5px",
    margin: 0,
    "@media (max-width:600px)": { fontSize: 20 },
  },
  featuredDesc: {
    fontSize: 14,
    lineHeight: 1.65,
    color: "rgba(255,255,255,0.62)",
    margin: 0,
  },
  watchBtn: {
    alignSelf: "flex-start",
    color: theme.palette.primary.main,
    border: `1px solid rgba(250,255,105,0.4)`,
    borderRadius: 999,
    padding: "9px 20px",
    fontSize: 11,
    letterSpacing: "2px",
    fontWeight: 700,
    marginTop: "auto",
    transition: "background .25s, color .25s, border-color .25s",
  },

  /* grid */
  gridLabel: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "#666",
    margin: "80px 0 24px",
    "@media (max-width:600px)": { marginTop: 56 },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 24,
    "@media (max-width:900px)": { gridTemplateColumns: "repeat(2, 1fr)" },
    "@media (max-width:600px)": { gridTemplateColumns: "1fr" },
  },
  card: {
    background: "#101010",
    borderRadius: 16,
    overflow: "hidden",
    border: "1px solid rgba(255,255,255,0.05)",
    display: "flex",
    flexDirection: "column",
    textDecoration: "none",
    color: "inherit",
    cursor: "pointer",
    opacity: 0,
    transform: "translateY(24px)",
    transition:
      "opacity .7s ease, transform .7s cubic-bezier(.2,.7,.2,1), border-color .3s",
    "&:hover": { borderColor: "rgba(255,255,255,0.18)" },
    "&:hover $cardImg": { transform: "scale(1.05)" },
    "&:hover $cardWatch": { color: theme.palette.primary.main, gap: 10 },
  },
  cardVisible: {
    opacity: 1,
    transform: "translateY(0)",
  },
  cardImgWrap: {
    width: "100%",
    aspectRatio: "16 / 10",
    overflow: "hidden",
    position: "relative",
  },
  cardImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    transition: "transform .6s cubic-bezier(.2,.7,.2,1)",
  },
  cardImgOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, transparent 60%, rgba(0,0,0,0.6) 100%)",
    pointerEvents: "none",
  },
  cardBody: {
    padding: "20px 22px 24px",
    display: "flex",
    flexDirection: "column",
    gap: 8,
    flex: 1,
  },
  cardMetaRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: 11,
    letterSpacing: "2px",
    color: "rgba(255,255,255,0.5)",
    fontWeight: 600,
  },
  cardTitle: {
    fontSize: 17,
    fontWeight: 700,
    lineHeight: 1.35,
    marginTop: 4,
    letterSpacing: "-0.2px",
  },
  cardDesc: {
    fontSize: 13,
    lineHeight: 1.6,
    color: "rgba(255,255,255,0.55)",
  },
  cardWatch: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    color: "#888",
    fontSize: 11,
    letterSpacing: "2px",
    fontWeight: 700,
    marginTop: 12,
    transition: "color .25s, gap .25s",
  },
}));

function useReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return { ref, visible };
}

function MediaCard({ data, classes, index }) {
  const { ref, visible } = useReveal();
  return (
    <Box
      ref={ref}
      component="a"
      href={data.href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${classes.card} ${visible ? classes.cardVisible : ""}`}
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <Box className={classes.cardImgWrap}>
        <img src={data.image} alt={data.title} className={classes.cardImg} />
        <Box className={classes.cardImgOverlay} />
      </Box>
      <Box className={classes.cardBody}>
        <Box className={classes.cardMetaRow}>
          <span>{data.badge}</span>
          <span>{data.meta}</span>
        </Box>
        <Typography className={classes.cardTitle}>{data.title}</Typography>
        <Typography className={classes.cardDesc}>{data.description}</Typography>
        <Box className={classes.cardWatch}>WATCH →</Box>
      </Box>
    </Box>
  );
}

export default function Media() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Header />

      <Box component="section" className={classes.hero}>
        <Box className={classes.heroBgGradient} />
        <Box className={classes.heroInner}>
          <Typography className={classes.heroLabel}>
            Media — Press &amp; Productions
          </Typography>
          <Typography component="h1" className={classes.heroTitle}>
            Media
          </Typography>
          <Typography className={classes.heroSub}>
            방송, 라디오, 영상 — SoriSori AI의 기술이 닿은 순간들을 한곳에 모았습니다.
          </Typography>
        </Box>
      </Box>

      <Box component="section" className={classes.section}>
        <Box className={classes.inner}>
          <Box
            className={classes.featured}
            component="a"
            href={FEATURED.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box className={classes.featuredImageWrap}>
              <img
                src={FEATURED.image}
                alt={FEATURED.meta}
                className={classes.featuredImage}
              />
              <Box className={classes.featuredImageOverlay} />
            </Box>
            <Box className={classes.featuredBody}>
              <Box className={classes.badgeRow}>
                <Chip
                  label={FEATURED.badges[0]}
                  className={classes.badgeFeatured}
                />
                <Chip
                  label={FEATURED.badges[1]}
                  className={classes.badgeMuted}
                />
              </Box>
              <Typography className={classes.meta}>{FEATURED.meta}</Typography>
              <Typography className={classes.featuredTitle}>
                {FEATURED.title}
              </Typography>
              <Typography className={classes.featuredDesc}>
                {FEATURED.description}
              </Typography>
              <Box className={classes.watchBtn}>{FEATURED.cta} →</Box>
            </Box>
          </Box>

          <Typography className={classes.gridLabel}>
            More Productions
          </Typography>
          <Box className={classes.grid}>
            {ITEMS.map((item, i) => (
              <MediaCard
                key={item.title}
                data={item}
                classes={classes}
                index={i}
              />
            ))}
          </Box>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
}
